export default __webpack_public_path__ + "static/media/office11small.0c2cd5c6.jpg";